import $ from "jquery";

class Like {
  constructor() {
    this.events();
  }

  events() {
    $(".like-box").on("click", this.ourClickDispatcher.bind(this));
  }

  // methods
  ourClickDispatcher(e) {
    var currentLikeBox = $(e.target).closest(".like-box");

    if (currentLikeBox.attr("data-exists") == "yes") {
      //   alert("delete");
      this.deleteLike(currentLikeBox);
    } else {
      //   alert("create");
      this.createLike(currentLikeBox);
    }
  }

  createLike(currentLikeBox) {
    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", lovelearnintegrateData.nonce);
      },
      url:
        lovelearnintegrateData.root_url +
        "/wp-json/learningitemintegrate/v1/manageLike",
      type: "POST",
      data: {
        learningitemId: currentLikeBox.data("learningitemid"),
        trace: "0033",
      },
      success: (response) => {
        currentLikeBox.attr("data-exists", "yes");
        var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);
        likeCount++;
        currentLikeBox.find(".like-count").html(likeCount);
        currentLikeBox.attr("data-likeid", response);
        console.log(response);
        console.log(" check006");
      },
      error: (response) => {
        console.log(response);
        console.log(" check007");
      },
    });
  }

  deleteLike(currentLikeBox) {
    $.ajax({
      beforeSend: (xhr) => {
        xhr.setRequestHeader("X-WP-Nonce", lovelearnintegrateData.nonce);
      },
      url:
        lovelearnintegrateData.root_url +
        "/wp-json/learningitemintegrate/v1/manageLike",
      data: { likeid: currentLikeBox.attr("data-likeid") },
      type: "DELETE",
      success: (response) => {
        currentLikeBox.attr("data-exists", "no");
        //    alert("001before data-exists:no");
        var likeCount = parseInt(currentLikeBox.find(".like-count").html(), 10);
        //    alert("001 likeCount" + likeCount);
        likeCount--;
        //    alert("002 likeCount" + likeCount);
        currentLikeBox.find(".like-count").html(likeCount);
        currentLikeBox.attr("data-likeid", "");
        console.log(response);
        console.log(" check009");
      },
      error: (response) => {
        console.log(response);
        console.log(" check010");
      },
    });
  }
}

export default Like;
